module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addQualification":"Add qualification"},"fr":{"addQualification":"Ajout d\u0027une qualification"}}')
  delete Component.options._Ctor
}
